var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.549,
    height: 53.549,
    viewBox: "0 0 53.549 53.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M53.549,26.775A26.774,26.774,0,1,0,26.774,53.549c.157,0,.314,0,.471-.006V32.7H21.493V26h5.752V21.063c0-5.721,3.493-8.835,8.6-8.835A47.352,47.352,0,0,1,41,12.491v5.979H37.479c-2.776,0-3.314,1.32-3.314,3.256V26H40.8l-.865,6.7H34.165V52.515a26.789,26.789,0,0,0,19.384-25.74Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.52e3fe99fd2afe3bc528b063c91d6eb5.svg";
export { ForwardRef as ReactComponent };